var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    width: 27,
    height: 27.602,
    fill: "#00246a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M21.556,27.6H5.446A5.451,5.451,0,0,1,0,22.156V10.8A5.25,5.25,0,0,1,2.334,6.434L10.624.883a5.181,5.181,0,0,1,5.792,0L24.7,6.453A5.188,5.188,0,0,1,27,10.768V22.156A5.451,5.451,0,0,1,21.556,27.6M13.517,2.332a2.864,2.864,0,0,0-1.6.487L3.631,8.369h0a2.924,2.924,0,0,0-1.3,2.434V22.156a3.121,3.121,0,0,0,3.117,3.115h16.11a3.12,3.12,0,0,0,3.115-3.115V10.768A2.861,2.861,0,0,0,23.4,8.387L15.118,2.821a2.872,2.872,0,0,0-1.6-.489M2.982,7.4h0Z",
    transform: "translate(0 0)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.eb3c30b219bfb56b83242899648966a6.svg";
export { ForwardRef as ReactComponent };